module.exports = __webpack_public_path__ + "img/100pourcent.adc4262e.png";